import type { DMConversationMessage } from '@/components/pages/conversations/SocialInbox/types';

import { BaseMedia } from './BaseMedia';

type VideoFileInfo = {
    width: number;
    height: number;
    size: number;
    mime_type: string;
    aspect_ratio: number;
    audio_bitrate: number;
    video_bitrate: number;
    duration: number;
    framerate: number;
    pixel_size: number;
};

const DEFAULT_DIMENSION = 256;

export class VideoMedia extends BaseMedia {
    type: 'video';
    video: string;
    thumbnail: string;
    file_info: VideoFileInfo;

    constructor(attachment: DMConversationMessage['attachments'][0]) {
        super(attachment);
        this.type = 'video';
        this.video = attachment.url;
        this.thumbnail = attachment.preview_url || attachment.url;

        const width = parseInt(attachment.width || '0', 10) || DEFAULT_DIMENSION;
        const height = parseInt(attachment.height || '0', 10) || DEFAULT_DIMENSION;

        this.file_info = {
            width,
            height,
            size: 0,
            mime_type: attachment.type || 'video/mp4',
            aspect_ratio: height > 0 ? width / height : 1,
            audio_bitrate: 0,
            video_bitrate: 0,
            duration: 0,
            framerate: 0,
            pixel_size: 0
        };
    }
}
